module.exports = __webpack_public_path__ + "pc/img/noData.bb0f9f52.png";